import React from "react";

// As ações da página (busca, filtros, "novo...").
//
// No desktop ficam encostadas à direita. No celular ocupam a linha inteira e
// quebram entre si: com `shrink-0` e sem `flex-wrap`, telas como Contatos
// montavam uma faixa de 1100px de largura, e tudo depois do primeiro botão
// ficava fora da tela — inalcançável, porque quem rola é o corpo da página,
// não o cabeçalho.
const MainHeaderButtonsWrapper = ({ children }) => {
	return (
		<div className="flex w-full flex-wrap items-center gap-2 sm:ml-auto sm:w-auto sm:shrink-0 sm:flex-nowrap">
			{children}
		</div>
	);
};

export default MainHeaderButtonsWrapper;
